import { Box, BoxProps, Container, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import clsx from "clsx"

export interface IPageLayoutProps extends BoxProps {
  header?: JSX.Element | null
  footer?: JSX.Element | null
}

export const PageLayout: React.FC<IPageLayoutProps> = ({
  children,
  header = null,
  footer = null,
  sx = {},
  className,
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides = theme.components[`AppPageLayout`]?.styleOverrides || {}
  const { root, container, headerWrapper } = styleOverrides

  return (
    <Box
      sx={deepmerge(root, sx)}
      {...props}
      className={clsx("AppPageLayout-root", className)}
      data-name="PageLayout"
    >
      <Box sx={headerWrapper} className="AppPageLayout-headerWrapper">
        {header}
      </Box>
      <Container
        maxWidth="md"
        className="AppPageLayout-container"
        sx={container}
      >
        {children}
      </Container>
    </Box>
  )
}
